import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Button } from "@/components/Buttons";
import { HiddenField, SingleCheckboxField } from "@/components/Form/Parts/index";
import routes from "@/lib/routes";
import { useApolloClient } from "@apollo/client";
import { useSignupQuery, useAccountIdcTokenSignupMutation, useClearRecommendArticleMutation } from "@/hooks";
import yupAgeValidate from "@/lib/yupAgeValidate";
import yupPasswordValidate from "@/lib/yupPasswordValidate";
import formStyles from "@/styles/Form.module.scss";
import processStyles from "@/styles/Process.module.scss";
import { yupResolver } from "@hookform/resolvers/yup";
import { v4 as uuidv4 } from "uuid";
import Link from "next/link";
import { useState, useMemo, useCallback } from "react";
import { useForm } from "react-hook-form";
import * as y from "yup";
import ErrorMessage from "./Parts/ErrorMessage";
import RecommendArticleForm from "./RecommendArticleForm";
import Loading from "../Loading";
import crypto from "crypto";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
yupAgeValidate(y);
yupPasswordValidate(y);
const schema = y.object().shape({
  terms: y.boolean().oneOf([true], "規約に同意してください。")
});
export default function SignupForm() {
  var _errors$terms, _errors$termsAd, _errors$terms_mail;
  const {
    formState,
    register,
    handleSubmit,
    errors
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all"
  });
  const {
    isDirty,
    isValid,
    isSubmitting
  } = formState;
  const {
    data,
    loading: termloading
  } = useSignupQuery({
    variables: {}
  });
  const {
    requiredTerms,
    optionalTerms,
    recommendArticle
  } = data !== null && data !== void 0 ? data : {};
  const {
    courses,
    products
  } = recommendArticle !== null && recommendArticle !== void 0 ? recommendArticle : {};
  const hasRecommendArticle = courses || products;
  const {
    0: recommend,
    1: setRecommend
  } = useState();
  const {
    0: submited,
    1: setSubmited
  } = useState(false);
  const client = useApolloClient();
  const [signup, {
    error: signupError
  }] = useAccountIdcTokenSignupMutation();
  const [clearRecommendArticle] = useClearRecommendArticleMutation();
  const onSubmit = useCallback(async (data, recommend) => {
    return new Promise(async (resolve, reject) => {
      try {
        const terms = (() => {
          let values = [];
          if (data.terms) {
            values.push(data.termsValue);
          }
          if (data.termsAd) {
            values.push(data.termsAdValue);
          }
          if (data.termsMail) {
            values.push(data.termsMailValue);
          }
          if (values.length > 0) {
            return values.join(",");
          } else {
            return null;
          }
        })();
        const signupParams = _objectSpread(_objectSpread({}, data), {}, {
          terms,
          signature: uuidv4(),
          password: crypto.randomBytes(8).toString("hex") //ランダムな文字列をセット
        });

        if (!submited) {
          setSubmited(true);
          await signup({
            variables: signupParams
          });
          // 任意規約の表示を行ったのでAPIをコール
          await fetch("/api/optional_terms", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              confirm: true
            })
          });
          await clearRecommendArticle();
          client.resetStore().then(() => {
            if (recommend && recommend.type === "svod") {
              window.location.href = routes.svodPaymentAfterSignUp(recommend.id[0]);
            } else if (recommend && recommend.type === "tvod") {
              window.location.href = routes.tvodPaymentAfterSignUp(recommend.id[0]);
            } else {
              window.location.href = routes.signupComplete;
            }
            resolve();
          });
        }
      } catch (e) {
        setSubmited(false);
        console.log(e);
        reject();
      }
    });
  }, [submited]);
  const relayOnSubmit = useCallback(data => {
    onSubmit(data, recommend);
  }, [recommend, onSubmit]);
  const terms = useMemo(() => {
    if (requiredTerms) {
      const links = requiredTerms.map(term => /*#__PURE__*/_jsx(Link, {
        href: term.current_revision.url,
        target: "_blank",
        rel: "noopener noreferrer",
        children: term.display_name
      }, term.id_key));
      const value = requiredTerms.map(term => term.current_revision.unique_key);
      return {
        links,
        value
      };
    } else {
      return {};
    }
  }, [requiredTerms]);
  const adTerm = useMemo(() => {
    if (optionalTerms) {
      const term = optionalTerms.find(term => term.id_key === "ad");
      if (term) {
        return {
          link: term.current_revision.url,
          value: term.current_revision.unique_key
        };
      }
    }
    return null;
  }, [optionalTerms]);
  const mailTerm = useMemo(() => {
    if (optionalTerms) {
      const key = "spoox_mail";
      const term = optionalTerms.find(term => term.id_key === key);
      if (term) {
        return {
          link: term.current_revision.url,
          value: term.current_revision.unique_key
        };
      }
    }
    return null;
  }, [optionalTerms]);
  return /*#__PURE__*/_jsxs("form", {
    onSubmit: handleSubmit(relayOnSubmit),
    noValidate: true,
    children: [termloading && /*#__PURE__*/_jsx(Loading, {
      fixed: true
    }), !termloading && /*#__PURE__*/_jsx("div", {
      className: processStyles.contentWrapper,
      children: /*#__PURE__*/_jsxs("div", {
        className: processStyles.content,
        children: [terms && /*#__PURE__*/_jsxs("fieldset", {
          className: formStyles.basicFieldset,
          children: [/*#__PURE__*/_jsx(SingleCheckboxField, {
            ref: register,
            title: "\u898F\u7D04\u306E\u78BA\u8A8D\u3068\u540C\u610F",
            name: "terms",
            defaultChecked: false,
            label: /*#__PURE__*/_jsxs("p", {
              className: formStyles.terms,
              children: [terms.links, "\u3092\u78BA\u8A8D\u306E\u4E0A\u3001\u540C\u610F\u3059\u308B", /*#__PURE__*/_jsx("br", {}), "\u203B\u672C\u4F1A\u54E1\u30B5\u30FC\u30D3\u30B9\u5951\u7D04\u3001\u304A\u3088\u3073\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u5951\u7D04\u306F\u3001\u500B\u4EBA\u304B\u3089\u306E\u7533\u8FBC\u307F\u306B\u9650\u308A\u53D7\u4ED8\u3051\u308B\u3082\u306E\u3068\u3057\u3001\u6CD5\u4EBA\u3001\u305D\u306E\u4ED6\u793E\u56E3\u30FB\u7D44\u5408\u7B49\u306E\u56E3\u4F53\u304B\u3089\u306E\u7533\u8FBC\u307F\u306F\u53D7\u4ED8\u3051\u305A\u3001\u3053\u308C\u3089\u306E\u8005\u3068\u306E\u9593\u3067\u306F\u3001\u672C\u4F1A\u54E1\u30B5\u30FC\u30D3\u30B9\u5951\u7D04\u306F\u6709\u52B9\u306B\u6210\u7ACB\u3057\u306A\u3044\u3082\u306E\u3068\u3057\u307E\u3059\u3002"]
            }),
            error: (_errors$terms = errors.terms) === null || _errors$terms === void 0 ? void 0 : _errors$terms.message,
            required: true
          }), /*#__PURE__*/_jsx(HiddenField, {
            ref: register,
            name: "termsValue",
            defaultValue: terms.value
          })]
        }), adTerm && /*#__PURE__*/_jsxs("fieldset", {
          className: formStyles.basicFieldset,
          children: [/*#__PURE__*/_jsx(SingleCheckboxField, {
            ref: register,
            title: "\u5E83\u544A\u306B\u304A\u3051\u308B\u30C7\u30FC\u30BF\u5229\u7528\u306E\u78BA\u8A8D\u3068\u540C\u610F",
            name: "termsAd",
            defaultChecked: false,
            label: /*#__PURE__*/_jsxs("p", {
              className: formStyles.terms,
              children: ["\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u72B6\u6CC1\u7B49\u3092\u304A\u5BA2\u69D8\u306E\u8DA3\u5473\u30FB\u55DC\u597D\u7B49\u306B\u5408\u81F4\u3057\u305F\u60C5\u5831\u306E\u63D0\u4F9B\u7B49\u306B\u5229\u7528\u3059\u308B\u3053\u3068\u306B\u540C\u610F\u3059\u308B(\u8A73\u7D30\u306F", /*#__PURE__*/_jsx(Link, {
                href: adTerm.link,
                target: "_blank",
                rel: "noopener noreferrer",
                children: "\u3053\u3061\u3089"
              }), ")"]
            }),
            error: (_errors$termsAd = errors.termsAd) === null || _errors$termsAd === void 0 ? void 0 : _errors$termsAd.message
          }), /*#__PURE__*/_jsx(HiddenField, {
            ref: register,
            name: "termsAdValue",
            defaultValue: adTerm.value
          })]
        }), mailTerm && /*#__PURE__*/_jsxs("fieldset", {
          className: formStyles.basicFieldset,
          children: [/*#__PURE__*/_jsx(SingleCheckboxField, {
            ref: register,
            title: "\u3054\u6848\u5185\u30E1\u30FC\u30EB\u3078\u306E\u540C\u610F",
            name: "termsMail",
            defaultChecked: false,
            label: /*#__PURE__*/_jsxs("p", {
              className: formStyles.terms,
              children: ["\u672C\u30B5\u30FC\u30D3\u30B9\u304B\u3089\u306E\u3054\u6848\u5185\u30E1\u30FC\u30EB\u306E\u9001\u4ED8\u306B\u540C\u610F\u3059\u308B(\u8A73\u7D30\u306F", /*#__PURE__*/_jsx(Link, {
                href: mailTerm.link,
                target: "_blank",
                rel: "noopener noreferrer",
                children: "\u3053\u3061\u3089"
              }), ")"]
            }),
            error: (_errors$terms_mail = errors.terms_mail) === null || _errors$terms_mail === void 0 ? void 0 : _errors$terms_mail.message
          }), /*#__PURE__*/_jsx(HiddenField, {
            ref: register,
            name: "termsMailValue",
            defaultValue: mailTerm.value
          })]
        })]
      })
    }), signupError && /*#__PURE__*/_jsx(ErrorMessage, {
      msg: signupError === null || signupError === void 0 ? void 0 : signupError.message
    }), /*#__PURE__*/_jsx(RecommendArticleForm, {
      recommendArticle: recommendArticle,
      onChange: setRecommend
    }), /*#__PURE__*/_jsx("div", {
      className: formStyles.btnArea,
      children: /*#__PURE__*/_jsxs(Button, {
        type: "submit",
        fillColor: true,
        large: true,
        fontFixed: true,
        disabled: !isDirty || !isValid,
        disabledWithGray: true,
        loading: submited || isSubmitting,
        children: [!hasRecommendArticle && "利用登録する", hasRecommendArticle && "利用登録完了し、購入手続きへ"]
      })
    })]
  });
}